export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'és',
'_.loadingSpinnerText': 'Kérjük várjon...',
'pageTimerMax.text': 'Az idő letelte után automatikusan a következő oldalra lesz átirányítva.',
'pageTimerMax.timeLeft': 'A hátralévő idő',
'pageTimerMin.text': 'Az idő lejárta előtt nincs lehetőség a továbblépésre.',
'pageTimerMin.timeLeft': 'A hátralévő idő',
'pageTimerMin.allowNext': 'Továbbléphet',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Szeretném megkapni a hírlevelet',
'survey.registerForm.label.regulations': 'Elfogadom az Adatvédelmi szabályzatot és az Általános Szerződési Feltételeket',
'survey.registerForm.button.register': 'Regisztráció',
'survey.registerForm.registered': 'Köszönjük a regisztrációt. Egy aktiváló linket tartalmazó e-mailt küldtünk az Ön postaládájába.',
'survey.registerForm.cardHeader': 'Regisztráljon és kapjon pontokat!',
'survey.registerForm.cardBody': 'A felmérés kitöltéséért a következőket kapta',
'survey.registerForm.cardBody2': 'A pontok jóváírásra kerülnek, miután regisztrált egy fiókot az swpanel.co.uk oldalon. Adja meg e-mail címét, és regisztráljon fiókot a swpanel.pl oldalon.',
'survey.notProperDevice': 'Sajnos ezen az eszközön nem tudja kitölteni ezt a felmérést.',
'survey.properDevices': 'A felmérés a következő eszközökről érhető el:',
'survey.device-phone': 'okostelefon',
'survey.device-tablet': 'tablett',
'survey.device-desktop': 'számítógép / laptop',
'nextSurveys.header.seeAlso': 'Láss más felmérést is',
'nextSurveys.button.fill': 'Kitöltés',
'question.noContent': 'A kérdés tartalma hiányzik',
'question.input.placeholder.typeYourAnswer': 'Írja be válaszát',

'question.conjoint.go': 'Kattintson a "Tovább" gombra',
'question.matrix.carousel.go': 'Kattintson a "Tovább" gombra',
'question.carousel.prevBtn': 'Előző kijelentés',
'question.carousel.nextBtn': 'Következő kijelentés',

'question.open.email.inputPlaceholder': 'Adja meg az e-mail címét',
'question.open.email.emailVerify.sendCode': 'Ellenőrző kód elküldése',
'question.open.email.emailVerify.enderCode': 'Írja be a megkapott kódot',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Adja meg a kódot',
'question.open.email.emailVerify.confirm': 'Erősítse meg a címet.',
'question.open.email.emailVerify.codeIncorrect': 'A megadott kód helytelen',
'question.open.email.emailVerify.codeCorrect': 'E-mail cím helyesen ellenőrizve',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Töltés szüneteltetése',
'footer.buttonPrev.text': 'Visszalépés',
'footer.buttonClear.text': 'Törlés',
'footer.buttonNext.text': 'Tovább',
'footer.buttonEnd.text': 'Befejezés',
'footer.buttonStart.text': 'Felmérés indítása',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
